/* TORQ: product card hover video.
   On mouse hover the card's spin video fades in over the image and loops;
   on leave it fades out and pauses. The <video> is cloned from a <template>
   on first hover so nothing downloads until then. Touch and reduced-motion
   users keep the static image. */
if (!customElements.get('torq-card-video')) {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  customElements.define(
    'torq-card-video',
    class TorqCardVideo extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('.card-wrapper');
        if (!this.card) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.card.addEventListener('pointerenter', this.onEnter.bind(this), { signal });
        this.card.addEventListener('pointerleave', this.onLeave.bind(this), { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onEnter(event) {
        if (event.pointerType === 'touch' || !canHover.matches || reducedMotion.matches) return;
        this.hovering = true;

        if (!this.video) {
          this.video = this.querySelector('template').content.firstElementChild.cloneNode(true);
          this.video.muted = true;
          this.video.addEventListener('playing', () => {
            if (this.hovering) this.classList.add('is-playing');
          });
          this.append(this.video);
        } else if (this.video.paused) {
          this.video.currentTime = 0;
        }

        this.video.play()?.catch(() => {});
      }

      onLeave() {
        this.hovering = false;
        this.classList.remove('is-playing');
        this.video?.pause();
      }
    }
  );
}
